import Reports from './Reports';
export default Reports; 



// WEBPACK FOOTER //
// ./src/scenes/Reports/index.js